var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Reducers implements a pattern of subscribing to a Redux event, and selecting
 * the subscriber to modify state based on the event being sent to Redux.
 *
 * @param A type parameter identifying the enum or union of valid `type`
 * values used to identify redux events.
 * @param State type parameter identifying the root type of the Redux state
 * for which the Reducers will be used.
 */
var Reducers = /** @class */ (function () {
    /**
     *
     * @param actions
     * @param map
     */
    function Reducers(map) {
        this.map = map;
    }
    /**
     *
     */
    Reducers.create = function () {
        return new Reducers({});
    };
    /**
     *
     * @param reducers
     */
    Reducers.chainReducers = function () {
        var reducers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            reducers[_i] = arguments[_i];
        }
        return function (s, a) {
            var e_1, _a;
            var state = s;
            try {
                for (var reducers_1 = __values(reducers), reducers_1_1 = reducers_1.next(); !reducers_1_1.done; reducers_1_1 = reducers_1.next()) {
                    var red = reducers_1_1.value;
                    state = red(state, a);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (reducers_1_1 && !reducers_1_1.done && (_a = reducers_1.return)) _a.call(reducers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return state;
        };
    };
    /**
     *
     * @param k the key identifying the Action type to subscribe to.
     * @param red a list of one of more reducers to subscribe to the action.
     * @param AType the action's type key (string).
     */
    Reducers.prototype.register = function (k) {
        var _a;
        var red = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            red[_i - 1] = arguments[_i];
        }
        if (!!this.map[k]) {
            throw new Error("duplicate reducer for key ".concat(k));
        }
        if (!red || red.length === 0) {
            throw new Error("no reducer provided for ".concat(k));
        }
        var reducer = (red.length === 1)
            ? red[0]
            : Reducers.chainReducers.apply(Reducers, __spreadArray([], __read(red), false));
        return new Reducers(__assign(__assign({}, this.map), (_a = {}, _a[k] = reducer, _a)));
    };
    /**
     *
     * @param s
     * @param a
     */
    Reducers.prototype.reduce = function (s, a) {
        if (a.type.startsWith("@@INIT") ||
            a.type.startsWith("@@redux/")) {
            return s;
        }
        var handler = this.map[a.type];
        if (!handler) {
            /* tslint:disable */
            console.error("[MARY-REDUX] no handler found for ".concat(a.type));
            /* tslint:enable */
            return s;
        }
        return handler(s, a);
    };
    return Reducers;
}());
export { Reducers };
